import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mobile-header" }
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_3 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_4 = { class: "admin-sidebar" }
const _hoisted_5 = { class: "sidebar-nav" }
const _hoisted_6 = { class: "sidebar-footer" }
const _hoisted_7 = { class: "admin-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["admin-layout", { 'sidebar-open': _ctx.sidebarOpen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "hamburger-btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sidebarOpen = !_ctx.sidebarOpen)),
        "aria-label": "Toggle menu"
      }, [
        (!_ctx.sidebarOpen)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("line", {
                x1: "3",
                y1: "6",
                x2: "21",
                y2: "6"
              }, null, -1),
              _createElementVNode("line", {
                x1: "3",
                y1: "12",
                x2: "21",
                y2: "12"
              }, null, -1),
              _createElementVNode("line", {
                x1: "3",
                y1: "18",
                x2: "21",
                y2: "18"
              }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock("svg", _hoisted_3, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("line", {
                x1: "18",
                y1: "6",
                x2: "6",
                y2: "18"
              }, null, -1),
              _createElementVNode("line", {
                x1: "6",
                y1: "6",
                x2: "18",
                y2: "18"
              }, null, -1)
            ]))]))
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "mobile-title" }, "PSK Admin", -1))
    ]),
    _createElementVNode("div", {
      class: "sidebar-overlay",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sidebarOpen = false))
    }),
    _createElementVNode("aside", _hoisted_4, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "sidebar-logo" }, "PSK Admin", -1)),
      _createElementVNode("nav", _hoisted_5, [
        _createVNode(_component_router_link, {
          to: "/admin/dashboard",
          class: "nav-item",
          "active-class": "active",
          onClick: _ctx.closeSidebar
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "18",
              height: "18",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("rect", {
                x: "3",
                y: "3",
                width: "7",
                height: "7"
              }),
              _createElementVNode("rect", {
                x: "14",
                y: "3",
                width: "7",
                height: "7"
              }),
              _createElementVNode("rect", {
                x: "14",
                y: "14",
                width: "7",
                height: "7"
              }),
              _createElementVNode("rect", {
                x: "3",
                y: "14",
                width: "7",
                height: "7"
              })
            ], -1),
            _createElementVNode("span", null, "Dashboard", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/admin/certificates",
          class: "nav-item",
          "active-class": "active",
          onClick: _ctx.closeSidebar
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "18",
              height: "18",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" }),
              _createElementVNode("polyline", { points: "14 2 14 8 20 8" }),
              _createElementVNode("line", {
                x1: "16",
                y1: "13",
                x2: "8",
                y2: "13"
              }),
              _createElementVNode("line", {
                x1: "16",
                y1: "17",
                x2: "8",
                y2: "17"
              })
            ], -1),
            _createElementVNode("span", null, "Сертификаты", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/admin/products",
          class: "nav-item",
          "active-class": "active",
          onClick: _ctx.closeSidebar
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "18",
              height: "18",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" }),
              _createElementVNode("polyline", { points: "3.27 6.96 12 12.01 20.73 6.96" }),
              _createElementVNode("line", {
                x1: "12",
                y1: "22.08",
                x2: "12",
                y2: "12"
              })
            ], -1),
            _createElementVNode("span", null, "Продукция", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/admin/vacancies",
          class: "nav-item",
          "active-class": "active",
          onClick: _ctx.closeSidebar
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "18",
              height: "18",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
              _createElementVNode("circle", {
                cx: "8.5",
                cy: "7",
                r: "4"
              }),
              _createElementVNode("line", {
                x1: "20",
                y1: "8",
                x2: "20",
                y2: "14"
              }),
              _createElementVNode("line", {
                x1: "23",
                y1: "11",
                x2: "17",
                y2: "11"
              })
            ], -1),
            _createElementVNode("span", null, "Вакансии", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/admin/call_requests",
          class: "nav-item",
          "active-class": "active",
          onClick: _ctx.closeSidebar
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "18",
              height: "18",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("path", { d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" })
            ], -1),
            _createElementVNode("span", null, "Звонки", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          class: "logout-btn",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, "Выйти")
      ])
    ]),
    _createElementVNode("main", _hoisted_7, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ], 2))
}